import { render } from "./PrintableReceipt.vue?vue&type=template&id=8177198e&scoped=true"
import script from "./PrintableReceipt.vue?vue&type=script&lang=js"
export * from "./PrintableReceipt.vue?vue&type=script&lang=js"

import "./PrintableReceipt.vue?vue&type=style&index=0&id=8177198e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8177198e"]])

export default __exports__